import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const PhotoSlotIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 58 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.832 21.807c.792 0 1.462.427 1.767 1.097l1.462 2.923h6.7a3.796 3.796 0 0 1 3.777 3.777v14.62A3.796 3.796 0 0 1 30.761 48H3.777A3.796 3.796 0 0 1 0 44.223V29.604a3.796 3.796 0 0 1 3.777-3.777h6.7l1.401-2.923c.366-.67 1.036-1.097 1.767-1.097zm-3.533 6.7a7.357 7.357 0 0 0-7.37 7.371c0 4.081 3.29 7.37 7.37 7.37 4.02 0 7.371-3.289 7.371-7.37 0-4.081-3.29-7.37-7.37-7.37zm0 2.376a4.995 4.995 0 1 1 0 9.99 4.995 4.995 0 0 1 0-9.99zM55.92 0c1.096 0 1.949.853 1.949 1.95v30.456c0 1.097-.853 1.95-1.95 1.95H37.767v-4.752c0-3.898-3.167-7.005-7.005-7.005h-4.69l-.548-1.157c-.548-1.097-1.401-1.95-2.498-2.437l5.787-6.579a2.261 2.261 0 0 1 3.411 0l7.37 8.528 3.412-3.715c.792-.914 2.254-.914 3.046 0l7.919 8.71V3.838H19.188V18.64H15.35V1.95C15.35.852 16.203 0 17.3 0zm-8.284 7.249a3.046 3.046 0 1 1 0 6.091 3.046 3.046 0 0 1 0-6.091z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

PhotoSlotIcon.propTypes = propTypes;

export default PhotoSlotIcon;
